export default __webpack_public_path__ + "static/media/background-grass1.ca78e686.png";